import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import "./component.css";
import styles from './BodyChiSiamoPage.module.css';
import { useIntl } from "react-intl";
import chiSiamoImage1 from "../assets/images/chi-siamo-image-1.jpg";
import chiiSiamoImage2 from "../assets/images/chi-siamo-image-2.jpg";

export const BodyChiSiamoPage = () => {

  const intl = useIntl();
  const { formatMessage } = intl;

  return (
    <>
      <Container>
        <Row className="align-items-center justify-content-center" style={{ marginTop: "8rem" }}>
          <Col
            md={{ span: 5, order: 1 }}
            lg={{ span: 6, order: 1 }}
            sm={{ span: 12, order: 1 }}
            xs={{ span: 12, order: 1 }}
          >
            <Card className="shadow border-0 text-dark border-card">
              <Card.Img
                src={chiSiamoImage1}
                alt="Card image"
              />
              <Card
                className={`text-white ${styles.titleLeftCard}`}
              >
                <div style={{ fontWeight: "bold" }}>
                  {formatMessage({ id: 'chiSiamoPage.ilPronto' })}
                </div>
              </Card>
            </Card>
          </Col>
          <Col
            md={{ span: 6, order: 2 }}
            lg={{ span: 6, order: 2 }}
            sm={{ span: 12, order: 2 }}
            xs={{ span: 12, order: 2 }}
            style={{ fontSize: "100%" }}
            className="mt-4 mt-md-0"
          >
            <Card
              className="border-0 text-dark border-card mt-4 mt-md-0"
              style={{ backgroundColor: "initial" }}
            >
              <Card.Body>
                <Card.Title style={{ fontWeight: "bold", fontSize: "140%" }}> {formatMessage({ id: 'chiSiamoPage.ilPronto' })}</Card.Title>
                <Card.Text style={{ fontSize: "60%" }}>{formatMessage({ id: 'chiSiamoPage.descrProntoSoccorso' })}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center" style={{ marginTop: "8rem" }}>
          <Col
            md={{ span: 5, order: 2 }}
            lg={{ span: 6, order: 2 }}
            sm={{ span: 12, order: 1 }}
            xs={{ span: 12, order: 1 }}
          >
            <Card className="shadow border-0 text-dark border-card">
              <Card.Img
                src={chiiSiamoImage2}
                alt="Card image"
              />
              <Card
                className={`text-white ${styles.titleRightCard}`}
              >
                <div style={{ fontWeight: "bold" }}>
                  {formatMessage({ id: 'chiSiamoPage.ilPronto' })}
                </div>
              </Card>
            </Card>
          </Col>
          <Col
            md={{ span: 6, order: 1 }}
            lg={{ span: 6, order: 1 }}
            sm={{ span: 12, order: 2 }}
            xs={{ span: 12, order: 2 }}
            className="mt-4 mt-md-0"
          >
            <Card
              className="border-0 text-dark border-card"
              style={{ backgroundColor: "initial" }}
            >
              <Card.Body>
                <Card.Text style={{ fontSize: "60%" }}>{formatMessage({ id: 'chiSiamoPage.descrStrutturaProntoSoccorso' })}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Row className="align-items-center justify-content-center" style={{ marginTop: "8rem", marginRight: 0 }}>
        <div className={`text-white container-fluid ${styles.infoContainer}`}>
          <h3 style={{ marginLeft: '2em', fontSize: '100%' }}><b>{formatMessage({ id: "chiSiamoPage.informazioniUtili" })}</b></h3>
        </div>
        <Card
          className="border-0 shadow text-dark border-card mt-4 mt-md-0"
          style={{ position: 'relative', top: '-2rem', maxWidth: '100%', width: "65%", padding: '1em', marginBottom: '1rem', borderRadius: '0' }}
        >
          <Card.Body>
            <Row>
              <Col
                md={{ span: 6 }}
                lg={{ span: 6 }}
                sm={{ span: 7 }}
                xs={{ span: 7 }}>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/visite-ed-esami/prenotazioni">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.prenotareVisite" })}</a>
                </Row>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/cartella-clini">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.richiedereCartelleCliniche" })}</a>
                </Row>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/vita-in-reparto">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.orariVisiteDegenti" })}</a>
                </Row>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/parcheggi">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.parcheggio" })}</a>
                </Row>
              </Col>
              <Col
                md={{ span: 6 }}
                lg={{ span: 6 }}
                sm={{ span: 7 }}
                xs={{ span: 7 }}>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/negozi-e-banca">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.bancaNegozi" })}</a>
                </Row>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/ristorazione">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.caffetteriaRistorante" })}</a>
                </Row>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/dove-alloggiare">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.struttureAlloggiConvenzionati" })}</a>
                </Row>
                <Row>
                  <a id={`${styles.a}`} href="https://www.policlinicocampusbiomedico.it/informazioni-utili/cappellania">{formatMessage({ id: "chiSiamoPage.labelsLinksInfo.cappellania" })}</a>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Row>
    </>
  );
};
